<template>
    <div class="diagnosis-list-container">
        <v-skeleton-loader
            class="ml-0"
            v-show="selectedArray.length === 0 && loadingSelected"
            v-for="item in 6"
            :key="'l'+item"
            type="list-item-two-line"
        />

        <template v-if="!takeOrder">
            <div
                v-for="(item, index) in selected"
                :key="'c'+index"
                v-show="selectedArray.length > 0 && !loadingSelected && (item && item.length > 0)"
                class="research-list"
            >
                <b>{{ index }}</b>

                <div class="research-list__property">
                    <div v-for="(it, ind) in item" :key="'h'+ind" class="research-list__property__item line">
                        <span>{{ it.answerPropertyName }}</span>
                        <svg
                            title="Удалить выбранное исследование"
                            @click="confirmDelete(it, ind, item)"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path d="M6 5L18.7279 17.7279" stroke="#AAAEB7" stroke-width="2" stroke-linecap="round"/>
                            <path d="M6 18L18.7279 5.27208" stroke="#AAAEB7" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                </div>
            </div>
        </template>

        <div v-else class="research-list" v-show="selectedArray.length > 0 && !loadingSelected">
            <draggable
                tag="div"
                class="research-list__property"
                :list="selectedArray"
                v-bind="dragOptions"
                @change="drag($event, selectedArray)"
                @start="dragging = true"
                @end="dragging = false"
                handle=".handle"
            >
                <transition-group type="transition">
                    <div
                        v-for="(item, index) in selectedArray"
                        :key="'selected_' + index"
                        class="research-list__property__item"
                    >
                        <InlineSvg
                            :src="require('../../../../../assets/img/drag.svg')"
                            width="24"
                            height="24"
                            stroke="#AAAEB7"
                            class="drag-icon handle"
                            :class="{ 'dragging': dragging }"
                        />
                        <div class="card" :class="{ 'dragging': dragging }">
                            <span><b>{{ item.answerGroupName }}</b><br />{{ item.answerPropertyName }}</span>
                            <svg
                                title="Удалить выбранное исследование"
                                @click="confirmDelete(item, index, selectedArray)"
                                class="delete"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path d="M6 5L18.7279 17.7279" stroke="#AAAEB7" stroke-width="2" stroke-linecap="round"/>
                                <path d="M6 18L18.7279 5.27208" stroke="#AAAEB7" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>

        <div class="diagnosis-list-container__not-result" v-show="selectedArray.length === 0 && !loadingSelected">
            Выбранных исследований нет...
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import InlineSvg from 'vue-inline-svg';
import './index.scss';

export default {
    name: 'SelectedResearches',
    components: { draggable, InlineSvg },
    props: {
        takeOrder: Boolean,
        loadingSelected: Boolean,
        selectedArray: Array,
        selected: Object
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: 'description',
                disabled: false
            };
        }
    },
    data: () => ({
        dragging: false
    }),
    methods: {
        drag(event, list) {
            this.$emit('drag', event, list);
        },
        confirmDelete(it, ind, item) {
            this.$emit('confirmDelete', it, ind, item);
        }        
    }
}
</script>
